import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Company } from '@shared/models/company';

@Component({
    selector: 'bcm-company-link',
    templateUrl: './company-link.component.html',
    standalone: false
})
export class CompanyLinkComponent {

    @Input()
    public company: Company;

    @Input()
    public prefix: string;

    @Input()
    public suffix: string;

    // detail tab to open, e.g. 'invoices' (Bierdeckel); defaults to the detail page's own redirect
    @Input()
    public routeTab: string;

    @Input()
    public dataTest: string;

    @Input()
    public disableLink: boolean;

    @Input()
    public openInNewTab = false;

    @Input()
    public showTenantRelations: boolean;

    @Input()
    public showTenantRelationWithLineBreak: boolean;

    @Output()
    public clicked = new EventEmitter<void>();

    click(event): void {
        this.clicked.emit();
        event.stopPropagation();
    }
}
